const RAINBOW_COLORS = [
    { id: 'red', name: 'Red', hex: '#ff3b3b', emoji: '🟥' },
    { id: 'orange', name: 'Orange', hex: '#ff9a3b', emoji: '🟧' },
    { id: 'yellow', name: 'Yellow', hex: '#ffd93b', emoji: '🟨' },
    { id: 'green', name: 'Green', hex: '#4ade80', emoji: '🟩' },
    { id: 'blue', name: 'Blue', hex: '#38bdf8', emoji: '🟦' },
    { id: 'purple', name: 'Purple', hex: '#a78bfa', emoji: '🟪' },
];

export const EXTENDED_COLORS = [
    { id: 'black', name: 'Black', hex: '#1c1c24', emoji: '⬛' },
    { id: 'white', name: 'White', hex: '#f4f4f6', emoji: '⬜' },
    { id: 'brown', name: 'Brown', hex: '#8a5a35', emoji: '🟫' },
    { id: 'pink', name: 'Pink', hex: '#ff6fb0', emoji: '🩷' },
    { id: 'silver', name: 'Silver', hex: '#c4c8d0', emoji: '🔘' },
    { id: 'pattern', name: 'Pattern', hex: '#ff3bd4', emoji: '🏁' },
];

export default RAINBOW_COLORS;
